// "ASSISTANT" / "MANAGER" su due righe, maiuscolo, lettere distribuite (justify)
// così entrambe le parole occupano esattamente la stessa larghezza.
export function BrandLabel({ className = "", style }) {
  const words = ["ASSISTANT", "MANAGER"];
  return (
    <div className={className} style={style}>
      {words.map((w) => (
        <span key={w} className="flex justify-between w-full leading-[1.05]">
          {w.split("").map((c, i) => (
            <span key={`${w}-${i}`}>{c}</span>
          ))}
        </span>
      ))}
    </div>
  );
}
